import React from 'react';
import {CheckBox} from "./CheckBox";
import _ from "lodash";
import {CheckBoxOption} from "./CommonUIElementTypes";

interface CheckBoxSetProps {
    onChange: Function;
    values: string[];
    options: CheckBoxOption[];
}

export let CheckBoxSet = function (props: CheckBoxSetProps) {
    function onChange(option: CheckBoxOption, checked: boolean) {
        let updatedValues = _.cloneDeep(props.values || [])
        if (updatedValues.includes(option.value as string) && !checked) {
            updatedValues = _.filter(updatedValues, (pickedValue) => {
                return pickedValue !== option.value
            })
        } else if (!updatedValues.includes(option.value as string) && checked) {
            updatedValues.push(option.value as string)
        }
        updatedValues = _.uniq(updatedValues)
        props.onChange(updatedValues);
    }

    let checkboxesDisplay = [];
    for (let i = 0; i < props.options.length; i++) {
        let option: CheckBoxOption = props.options[i];
        checkboxesDisplay.push(
            <CheckBox
                key={i}
                id={`stripePaymentMethod-${option.value}`}
                checked={(props.values || []).includes(option.value as string)}
                onChange={(checked: boolean) => onChange(option, checked)}
                label={option.label}
                sublabel={option.sublabel}
                disabled={option.disabled}
            />
        )
    }

    return (
        <div className="common-form-checkbox-set">
            {checkboxesDisplay}
        </div>
    );
};
